import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import HikalLeadForm from '../../../../components/LeadForm/HikalLeadForm';
import HikalLeadFormLuxury from '../../../../components/LeadForm/HikalLeadFormLuxury';

function BinghattiSkybladeHikal({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName === 'United Arab Emirates';
    // const isSaudia = userInfo?.countryName === 'Saudi Arabia';
    // const isSaudia = true;


    const images = [
        "/assets/images/projects/binghatti-skyblade/1.webp",
        "/assets/images/projects/binghatti-skyblade/2.webp",
    ];

    const poster = "/assets/images/projects/binghatti-skyblade/1.webp";
    const webm = "/assets/images/projects/binghatti-skyblade/hero.webm";
    const mp4 = "/assets/images/projects/binghatti-skyblade/hero.mp4";

    return (
        <>
            <div>
                <NoiseBackground />

                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/projects/binghatti/skyblade"
                        : "/projects/binghatti/skyblade/ar"
                    }
                />

                {/* IMAGES */}
                <div className="fixed top-0 left-0 w-full flex justify-center -z-1 lg:hidden" style={{ zIndex: 0 }}>
                    <video
                        autoPlay={true}
                        loop={true}
                        muted={true}
                        playsInline={true}
                        preload="auto"
                        poster={poster}
                        width="350"
                        height="350"
                        className={`w-full md:max-w-[550px]`}
                    >
                        <source src={webm} type="video/webm" />
                        <source src={mp4} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:px-[7%]">
                    <div className="h-full w-full items-center justify-center hidden lg:flex">
                        <video
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline={true}
                            preload="auto"
                            poster={poster}
                            width="350"
                            height="350"
                            className={`w-full md:max-w-[550px] rounded-sm`}
                        >
                            <source src={webm} type="video/webm" />
                            <source src={mp4} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    {/* HEADING */}
                    <div className="relative px-[7%] lg:px-0 text-center my-5 py-5 z-1 flex flex-col gap-10 items-center" style={{ zIndex: 1 }}>
                        <div className="h-[300px] md:h-[400px] lg:h-0"></div>
                        <div className="luxury-card flex flex-col gap-10 py-6 p-4">
                            <div>
                                {language === "ar"
                                    ? (isUAE ? (
                                        <h1 className="goldentext text-center px-2 my-1 text-lg lg:text-2xl">
                                            تخيل انك تسكن أمام برج خليفة مباشرة
                                            <br />
                                            وتتمشي خطوات لدبي مول والبوليفارد
                                            <br />
                                            في أخر قطعة أرض بالداون تاون
                                            <br />
                                            <span>
                                                أحجز ب
                                            </span>
                                            <span className="text-2xl lg:text-4xl px-2">
                                                50
                                            </span>
                                            <span>
                                                الف درهم فرصتك قبل الطرح
                                            </span>
                                        </h1>
                                    ) : (
                                        <h1 className="goldentext text-center px-2 my-1 text-lg lg:text-2xl">
                                            تخيل انك تسكن أمام برج خليفة مباشرة
                                            <br />
                                            وتتمشي خطوات لدبي مول والبوليفارد
                                            <br />
                                            في أخر قطعة أرض بالداون تاون
                                            <br />
                                            <span>
                                                أحجز ب
                                            </span>
                                            <span className="text-2xl lg:text-4xl px-2">
                                                50
                                            </span>
                                            <span>
                                                الف درهم فرصتك قبل الطرح
                                            </span>
                                        </h1>
                                    ))
                                    : (isUAE ? (
                                        <>
                                            <h1 className="goldentext text-center px-2 my-1 pb-3 text-base lg:text-xl">
                                                Imagine living right in front of Burj Khalifa!
                                                <br />
                                                A few steps away from Dubai Mall and the Boulevard,
                                                <br />
                                                On the last plot of land in Downtown.
                                                <span>
                                                    Book now with
                                                </span>
                                                {/* <span className="text-2xl bounce-text secondary-text"> */}
                                                <span className="text-2xl lg:text-3xl px-2">
                                                    AED 50k
                                                </span>
                                                <span> only, your opportunity before the launch</span>
                                            </h1>
                                        </>
                                    ) : (
                                        <>
                                            <h1 className="goldentext text-center px-2 my-1 pb-3 text-base lg:text-xl">
                                                Imagine living right in front of Burj Khalifa!
                                                <br />
                                                A few steps away from Dubai Mall and the Boulevard,
                                                <br />
                                                On the last plot of land in Downtown.
                                                <span>
                                                    Book now with
                                                </span>
                                                {/* <span className="text-2xl bounce-text secondary-text"> */}
                                                <span className="text-2xl lg:text-3xl px-2">
                                                    AED 50k
                                                </span>
                                                <span> only, your opportunity before the launch</span>
                                            </h1>
                                        </>
                                    ))
                                }
                            </div>

                            {/* LIMITED TIME OFFER */}
                            <div className="w-full">
                                <div className="padding-container flex items-center justify-center">
                                    <Countdown addClass={"-luxury"} />
                                </div>
                            </div>

                            {/* LEAD FORM */}
                            <HikalLeadFormLuxury
                                developer="Binghatti"
                                project="Skyblade"
                                leadType="Apartment"
                                language={language === "ar" ? "Arabic" : "English"}
                                enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                                askEmail={false}
                            />
                        </div>
                    </div>
                </div>
            </div >

            {/* <div className="padding-container text-center my-5 py-5">
                {language === "ar"
                    ? (
                        <p className="px-2 my-1">
                            احجز الآن فقط بـ <strong>40,000</strong> درهم واستفد بأسعار ما قبل الطرح
                        </p>
                    )
                    : (
                        <p className="px-2 my-1">
                            Book now with just <strong>40,000</strong> AED and benefit from pre-launch prices.
                        </p>
                    )
                }
            </div> */}


            <Footer />
        </>
    );
}

export default BinghattiSkybladeHikal;
